import { IOverlayParameter } from "@/types/map";
import { loadModules } from "esri-loader";
import RippleRenderer from "./RippleRenderer";

export default class RippleLayer {
  private static intances: Map<string, RippleLayer>;

  public static getInstance(view: __esri.SceneView) {
    const id = view.container.id;
    if (!RippleLayer.intances) {
      RippleLayer.intances = new Map();
    }
    let instance = RippleLayer.intances.get(id);
    if (!instance) {
      instance = new RippleLayer(view);
      RippleLayer.intances.set(id, instance);
    }
    return instance;
  }

  private view!: __esri.SceneView;
  private rippleRenderer!: RippleRenderer;
  private initialized = false;

  private constructor(view: __esri.SceneView) {
    this.view = view;
  }

  private async initialize() {
    type MapModules = [
      typeof import("esri/views/3d/externalRenderers"),
      typeof import("esri/geometry/SpatialReference")
    ];
    const [externalRenderers, SpatialReference] = await (loadModules([
      "esri/views/3d/externalRenderers",
      "esri/geometry/SpatialReference",
    ]) as Promise<MapModules>);

    this.rippleRenderer = new RippleRenderer(
      this.view,
      externalRenderers,
      SpatialReference.WGS84
    );

    externalRenderers.add(this.view, this.rippleRenderer);
    this.initialized = true;
  }

  public async addPoints(params: IOverlayParameter) {
    if (!this.initialized) {
      await this.initialize();

      setTimeout(() => {
        this.rippleRenderer.updatePositions(params.overlays);
      }, 500);
    } else {
      this.rippleRenderer.updatePositions(params.overlays);
    }
  }
}
